/**
 * Migration 003 — Investigation hardening + KAIROS foundations.
 *
 * Adds:
 * - lifecycle_state + last_activity_at to investigations
 * - canonical_entities + canonical_identifiers + entity_canonical_map tables
 * - staging_proposals table (KAIROS queue)
 * - assessment_versions table (report revision tracking)
 * - Indexes for all new tables/columns
 */

export const MIGRATION_003_UP = `
-- Investigation lifecycle
ALTER TABLE investigations ADD COLUMN lifecycle_state TEXT DEFAULT 'review';
ALTER TABLE investigations ADD COLUMN last_activity_at DATETIME;

-- Canonical entity index
CREATE TABLE IF NOT EXISTS canonical_entities (
  canonical_id TEXT PRIMARY KEY,
  name TEXT NOT NULL,
  type TEXT NOT NULL,
  first_seen_at DATETIME NOT NULL,
  last_seen_at DATETIME NOT NULL,
  investigation_count INTEGER DEFAULT 1
);

CREATE TABLE IF NOT EXISTS canonical_identifiers (
  canonical_id TEXT NOT NULL,
  identifier_type TEXT NOT NULL,
  identifier_value TEXT NOT NULL,
  FOREIGN KEY (canonical_id) REFERENCES canonical_entities(canonical_id),
  PRIMARY KEY (canonical_id, identifier_type, identifier_value)
);

CREATE TABLE IF NOT EXISTS entity_canonical_map (
  entity_id TEXT NOT NULL,
  canonical_id TEXT NOT NULL,
  investigation_id TEXT NOT NULL,
  confidence REAL NOT NULL,
  match_type TEXT NOT NULL,
  linked_at DATETIME NOT NULL,
  PRIMARY KEY (entity_id, canonical_id, investigation_id),
  FOREIGN KEY (canonical_id) REFERENCES canonical_entities(canonical_id),
  FOREIGN KEY (investigation_id) REFERENCES investigations(id)
);

-- Staging queue for KAIROS proposals
CREATE TABLE IF NOT EXISTS staging_proposals (
  id TEXT PRIMARY KEY,
  proposal_type TEXT NOT NULL,
  source_investigation_id TEXT,
  target_investigation_id TEXT,
  entity_ids TEXT DEFAULT '[]',
  summary TEXT NOT NULL,
  detail TEXT NOT NULL,
  confidence REAL NOT NULL,
  tier INTEGER NOT NULL,
  status TEXT DEFAULT 'pending',
  created_at DATETIME NOT NULL,
  resolved_at DATETIME,
  resolved_by TEXT,
  FOREIGN KEY (source_investigation_id) REFERENCES investigations(id),
  FOREIGN KEY (target_investigation_id) REFERENCES investigations(id)
);

-- Report revision tracking
CREATE TABLE IF NOT EXISTS assessment_versions (
  id TEXT PRIMARY KEY,
  investigation_id TEXT NOT NULL,
  version INTEGER NOT NULL,
  content TEXT NOT NULL,
  created_at DATETIME NOT NULL,
  created_by TEXT NOT NULL DEFAULT 'system',
  FOREIGN KEY (investigation_id) REFERENCES investigations(id)
);

-- Indexes
CREATE INDEX IF NOT EXISTS idx_canonical_name_type ON canonical_entities(name, type);
CREATE INDEX IF NOT EXISTS idx_canonical_identifiers_value ON canonical_identifiers(identifier_type, identifier_value);
CREATE INDEX IF NOT EXISTS idx_canonical_map_canonical ON entity_canonical_map(canonical_id);
CREATE INDEX IF NOT EXISTS idx_canonical_map_investigation ON entity_canonical_map(investigation_id);
CREATE INDEX IF NOT EXISTS idx_proposals_status ON staging_proposals(status);
CREATE INDEX IF NOT EXISTS idx_proposals_type ON staging_proposals(proposal_type, status);
CREATE INDEX IF NOT EXISTS idx_lifecycle_state ON investigations(lifecycle_state);
CREATE INDEX IF NOT EXISTS idx_last_activity ON investigations(last_activity_at);
CREATE INDEX IF NOT EXISTS idx_assessment_versions ON assessment_versions(investigation_id, version);
`;

export const MIGRATION_003_DOWN = `
DROP INDEX IF EXISTS idx_assessment_versions;
DROP INDEX IF EXISTS idx_last_activity;
DROP INDEX IF EXISTS idx_lifecycle_state;
DROP INDEX IF EXISTS idx_proposals_type;
DROP INDEX IF EXISTS idx_proposals_status;
DROP INDEX IF EXISTS idx_canonical_map_investigation;
DROP INDEX IF EXISTS idx_canonical_map_canonical;
DROP INDEX IF EXISTS idx_canonical_identifiers_value;
DROP INDEX IF EXISTS idx_canonical_name_type;
DROP TABLE IF EXISTS assessment_versions;
DROP TABLE IF EXISTS staging_proposals;
DROP TABLE IF EXISTS entity_canonical_map;
DROP TABLE IF EXISTS canonical_identifiers;
DROP TABLE IF EXISTS canonical_entities;
`;
